// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused\n    > .v-input__control\n    > .v-input__slot[data-v-01a42472] {\n    background: #929292 !important;\n}\n", ""]);
// Exports
module.exports = exports;
